// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  min-height: 100%;
}

body {
  margin: 0;
  padding: 0;
  font-family: sans-serif;
}

.mboss-app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.mboss-app-main {
  flex: 1 0 auto;
  width: 100%;
}

.navbar {
  margin-bottom: 30px;
  flex-shrink: 0;
}

.mboss-topbar {
  min-height: 3.25rem;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  padding-left: 1rem;
  padding-right: 1rem;
  background: #f7f8fa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: none;
}

.mboss-topbar .navbar-brand {
  padding-top: 0;
  padding-bottom: 0;
}

.mboss-topbar .navbar-toggler {
  height: 2rem;
  width: 2rem;
  padding: 0;
  color: #5c6570;
}

.mboss-footer {
  flex-shrink: 0;
  margin-top: 1.5rem;
  background: #f7f8fa;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: none;
}

.mboss-footer__inner {
  max-width: 1140px;
  margin: 0 auto;
  padding: 0.65rem 1rem;
}

.mboss-footer__meta {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #6c757d;
  line-height: 1.3;
}

.mboss-footer__version {
  font-weight: 400;
  opacity: 0.9;
}

/* Quiet hierarchy sidebar rail (aligned with Admin Option B) */
.nav-section-list {
  --nav-rail-bg: #f7f8fa;
  --nav-rail-border: rgba(0, 0, 0, 0.08);
  --nav-item-fg: #3d4550;
  --nav-item-muted: #6c757d;
  --nav-item-hover-bg: rgba(0, 0, 0, 0.04);
  --nav-active-bg: rgba(0, 123, 255, 0.12);
  --nav-active-fg: #0056b3;
  --nav-active-bar: #007bff;
  --nav-section-fg: #5c6570;
  --nav-footer-border: rgba(0, 0, 0, 0.08);
  margin-bottom: 0;
}

.mboss-side-rail {
  position: sticky;
  top: 4.25rem;
  max-height: calc(100vh - 5rem);
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 0.25rem;
  overflow: hidden;
}

.nav-section-list--rail {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  height: 100%;
}

.nav-section-body {
  flex: 1 1 auto;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0.4rem 0.35rem 0.5rem;
}

.nav-section-footer {
  flex-shrink: 0;
  padding: 0.4rem 0.35rem 0.5rem;
  border-top: 1px solid var(--nav-footer-border);
  background: var(--nav-rail-bg, #f7f8fa);
}

.nav-section-list--mobile .nav-section-body {
  padding: 0.25rem 0;
}

.nav-link-item {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.5rem;
  margin: 0.1rem 0;
  padding: 0.6rem 0.75rem;
  border: none;
  border-radius: 0.3rem;
  background: transparent;
  color: var(--nav-item-fg, #3d4550);
  text-align: left;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.3;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
  box-shadow: none;
}

.nav-link-icon {
  flex: 0 0 1.25rem;
  width: 1.25rem;
  text-align: center;
  opacity: 0.85;
}

.nav-link-label {
  flex: 1 1 auto;
  min-width: 0;
}

.nav-link-item:hover {
  background-color: var(--nav-item-hover-bg, rgba(0, 0, 0, 0.04));
  color: var(--nav-item-fg, #3d4550);
  box-shadow: none;
  text-decoration: none;
}

.nav-link-item:focus {
  outline: none;
}

.nav-link-item:focus-visible {
  outline: 2px solid var(--nav-active-bar, #007bff);
  outline-offset: 1px;
}

.nav-section-list .nav-link-item.active,
.nav-section-list .nav-link-item.active:hover {
  background-color: var(--nav-active-bg, rgba(0, 123, 255, 0.12));
  color: var(--nav-active-fg, #0056b3);
  box-shadow: inset 3px 0 0 var(--nav-active-bar, #007bff);
  text-decoration: none;
}

.nav-section-list .nav-link-item.active .nav-link-icon {
  opacity: 1;
}

.nav-section-mobile-logout {
  margin-top: 0.35rem;
  padding-top: 0.35rem;
  border-top: 1px solid var(--nav-footer-border, rgba(0, 0, 0, 0.08));
}

.nav-section-list .list-group-item,
.nav-section-list .list-group-item:hover {
  box-shadow: none;
}


.clickable {
  cursor: pointer;
}

.form-signin {
  width: 100%;
  max-width: 350px;
  padding: 40px;
  /* margin: 50px auto; */
}

.form-input {
  width: 100%;
  max-width: 600px;
  padding: 15px;
  margin: 0 auto;
}

@media (max-width: 575px) {
  .form-group {
    margin-bottom: 0px !important;
  }
}

.activity-log {
  width: 100%;
  max-width: 600px;
  /* padding: 10px; */
  margin: 0 auto;
}

.ticket-comments {
  width: 100%;
  max-width: 600px;
  padding: 10px;
  margin: 0 auto;
}

.text-link {
  color: inherit;
  text-decoration: inherit;
}

.card-counter{
  box-shadow: 4px 4px 10px #DADADA;
  margin-bottom: 10px;
  padding: 20px 10px;
  background-color: #fff;
  height: 100px;
  border-radius: 5px;
  transition: .3s linear all;
}

.card-counter:hover{
  box-shadow: 8px 8px 20px #9e9e9e;
  transition: .3s linear all;
}

.card-counter:active{
  box-shadow: 1px 1px 5px #9e9e9e;
  transition: .3s linear all;
}
.card-counter.primary{
  background-color: #007bff;
  color: #FFF;
}

.card-counter.secondary{
  background-color: #6c757d;
  color: #FFF;
}  

.card-counter.danger{
  background-color: #ef5350;
  color: #FFF;
}  

.card-counter.warning{
  background-color: #ffc107;
  color: #FFF;
}  

.card-counter.success{
  background-color: #66bb6a;
  color: #FFF;
}  

.card-counter.info{
  background-color: #26c6da;
  color: #FFF;
}  

.card-counter.dark{
  background-color: #343a40;
  color: #FFF;
}  

.card-counter.light{
  background-color: #f8f9fa;
  color: #FFF;
}  

.card-counter i{
  font-size: 5em;
  opacity: 0.2;
}

.card-counter .count-numbers{
  position: absolute;
  right: 28px;
  top: 20px;
  font-size: 28px;
  display: block;
}

.card-counter .count-name{
  position: absolute;
  right: 28px;
  top: 65px;
  font-style: italic;
  text-transform: capitalize;
  opacity: 0.5;
  display: block;
  font-size: 18px;
}

:root[data-theme="dark"] .card-counter{
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.55);
}

:root[data-theme="dark"] .card-counter:hover{
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.7);
}

:root[data-theme="dark"] .card-counter:active{
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);
}

:root[data-theme="dark"] .table a,
:root[data-theme="dark"] table a {
  text-decoration: none !important;
}

:root[data-theme="dark"] .table a:hover,
:root[data-theme="dark"] table a:hover,
:root[data-theme="dark"] .table a:focus,
:root[data-theme="dark"] table a:focus {
  text-decoration: none !important;
}

:root[data-theme="dark"] .table-dark a,
:root[data-theme="dark"] table.table-dark a,
:root[data-theme="dark"] .table thead a,
:root[data-theme="dark"] .table tbody a,
:root[data-theme="dark"] .table tfoot a {
  text-decoration: none !important;
}

.list-group-item:hover {
  background-color: #f5f5f5;
  box-shadow: 0px 0px 2px #9e9e9e;
  transition: .3s linear all;
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.expandable-log .expand-toggle {
  display: none;
}

.expandable-log .log-content {
  max-height: 1.5em;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
}

.expandable-log .expand-toggle:checked ~ label .log-content {
  max-height: 1000px;
}

.expand-arrow {
  display: inline-block;
  transition: transform 0.2s;
  color: #6c757d;
  font-size: 0.875em;
}

.expandable-log .expand-toggle:checked ~ label .expand-arrow {
  transform: rotate(180deg);
}

:root[data-theme="dark"] body {
  background-color: #121212;
  color: #e9ecef;
}

:root[data-theme="dark"] .navbar,
:root[data-theme="dark"] .mboss-topbar {
  background-color: #1a1c1f !important;
  border-bottom-color: #2b2f33;
}

:root[data-theme="dark"] .mboss-topbar .navbar-toggler {
  color: #b0b8c1;
}

:root[data-theme="dark"] .navbar.navbar-light .navbar-brand,
:root[data-theme="dark"] .navbar.navbar-light .navbar-toggler,
:root[data-theme="dark"] .navbar.navbar-light .nav-link,
:root[data-theme="dark"] .mboss-topbar .navbar-brand,
:root[data-theme="dark"] .mboss-topbar .nav-link {
  color: #e9ecef !important;
}

:root[data-theme="dark"] .nav-section-list {
  --nav-rail-bg: #1a1c1f;
  --nav-rail-border: #2b2f33;
  --nav-item-fg: #e0e5ea;
  --nav-item-muted: #9aa3ad;
  --nav-item-hover-bg: rgba(255, 255, 255, 0.06);
  --nav-active-bg: rgba(0, 123, 255, 0.22);
  --nav-active-fg: #9ec9ff;
  --nav-active-bar: #4da3ff;
  --nav-section-fg: #b0b8c1;
  --nav-footer-border: #2b2f33;
}

:root[data-theme="dark"] .mboss-side-rail {
  background: #1a1c1f;
  border-color: #2b2f33;
}

:root[data-theme="dark"] .mboss-footer {
  background: #1a1c1f;
  border-top-color: #2b2f33;
}

:root[data-theme="dark"] .mboss-footer__meta {
  color: #9aa3ad;
}

:root[data-theme="dark"] .mboss-topbar {
  background-color: #1a1c1f !important;
  border-bottom-color: #2b2f33;
}

:root[data-theme="dark"] .mboss-topbar .navbar-toggler {
  color: #b0b8c1;
}

:root[data-theme="dark"] .nav-link-item {
  color: var(--nav-item-fg);
}

:root[data-theme="dark"] .nav-link-item:hover {
  background-color: var(--nav-item-hover-bg);
  color: var(--nav-item-fg);
}

:root[data-theme="dark"] .nav-section-list .nav-link-item.active,
:root[data-theme="dark"] .nav-section-list .nav-link-item.active:hover {
  background-color: var(--nav-active-bg);
  color: var(--nav-active-fg);
  box-shadow: inset 3px 0 0 var(--nav-active-bar);
}

:root[data-theme="dark"] a:not(.btn):not(.list-group-item):not(.nav-link-item) {
  color: inherit;
  text-decoration: none;
}


:root[data-theme="dark"] .card,
:root[data-theme="dark"] .modal-content,
:root[data-theme="dark"] .dropdown-menu {
  background-color: #1f1f1f;
  color: #e9ecef;
  border-color: #2b2f33;
}

/* Card-style table rows */
.table.table-cards {
  background: transparent;
  border-collapse: separate;
  border-spacing: 0 6px;
}

.table.table-cards thead th {
  border: none;
  padding-bottom: 16px;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
}

.table.table-cards tbody tr {
  background: #f8f9fa;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
  margin-bottom: 12px;
}

.table.table-cards tbody tr:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.table.table-cards tbody tr td {
  border: none;
  padding: 12px 10px;
  vertical-align: middle;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  white-space: normal;
  word-wrap: break-word;
  max-width: 200px;
}

.table.table-cards tbody tr td:first-child {
  border-left: 1px solid transparent;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.table.table-cards tbody tr td:last-child {
  border-right: 1px solid transparent;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

/* Optional subtle cell borders for readability */
.table.table-cards tbody tr td:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 20%;
  bottom: 20%;
  width: 1px;
  background: rgba(0, 0, 0, 0.06);
}

.table.table-cards tbody tr td {
  position: relative;
}

/* Dark mode */
:root[data-theme="dark"] .table.table-cards thead th {
  color: #adb5bd;
}

:root[data-theme="dark"] .table.table-cards tbody tr {
  background: #1e1f22;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

:root[data-theme="dark"] .table.table-cards tbody tr:hover {
  background: #2a2d31;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}

:root[data-theme="dark"] .table.table-cards tbody tr:hover td {
  color: #f3f4f6;
}

:root[data-theme="dark"] .table.table-cards tbody tr:hover td a {
  color: #60a5fa;
}

:root[data-theme="dark"] .table.table-cards tbody tr:hover td a:hover {
  color: #93c5fd;
}

:root[data-theme="dark"] .table.table-cards tbody tr td:not(:last-child)::after {
  background: rgba(255, 255, 255, 0.08);
}

:root[data-theme="dark"] .table {
  color: #d1d5db;
}

:root[data-theme="dark"] .table thead th {
  color: #e0e5ea;
}

:root[data-theme="dark"] .table td,
:root[data-theme="dark"] .table th {
  border-color: #2b2f33;
}

:root[data-theme="dark"] .list-group-item {
  background-color: #1f1f1f;
  color: #e9ecef;
  border-color: #2b2f33;
}

:root[data-theme="dark"] .list-group-item.active {
  background-color: #007bff;
  border-color: #007bff;
  color: #ffffff;
}

:root[data-theme="dark"] .list-group-item.active:hover {
  background-color: #0069d9;
  border-color: #0062cc;
  color: #ffffff;
}

:root[data-theme="dark"] .form-control,
:root[data-theme="dark"] .custom-select {
  background-color: #1b1b1b;
  color: #e9ecef;
  border-color: #2b2f33;
}

:root[data-theme="dark"] .form-control::placeholder {
  color: #adb5bd;
}

:root[data-theme="dark"] input[type="number"],
:root[data-theme="dark"] input[type="number"]::-webkit-inner-spin-button,
:root[data-theme="dark"] input[type="number"]::-webkit-outer-spin-button {
  color-scheme: dark;
}

:root[data-theme="dark"] input[type="number"]::-webkit-inner-spin-button,
:root[data-theme="dark"] input[type="number"]::-webkit-outer-spin-button {
  filter: invert(1) opacity(0.85);
}

:root[data-theme="dark"] .form-group .fa,
:root[data-theme="dark"] .input-group .fa {
  color: #e0e5ea;
}

:root[data-theme="dark"] .form-control + .btn .fa,
:root[data-theme="dark"] .form-control + button .fa {
  color: #e0e5ea;
}

:root[data-theme="dark"] .bg-light {
  background-color: #1f1f1f !important;
}

:root[data-theme="dark"] .text-dark {
  color: #e9ecef !important;
}

:root[data-theme="dark"] .text-secondary {
  color: #adb5bd !important;
}

:root[data-theme="dark"] a:not(.btn):not(.list-group-item):not(.nav-link-item) {
  color: inherit;
  text-decoration: underline;
}

:root[data-theme="dark"] a:not(.btn):not(.list-group-item):not(.nav-link-item):hover {
  color: inherit;
  opacity: 0.9;
}

:root[data-theme="dark"] .list-group-item:hover {
  background-color: #232323;
  box-shadow: 0px 0px 2px #343a40;
}

:root[data-theme="dark"] .page-link {
  background-color: #1f1f1f;
  border-color: #2b2f33;
  color: #e9ecef;
}

:root[data-theme="dark"] .page-link:hover {
  background-color: #232323;
  border-color: #3a3f44;
  color: #e9ecef;
}

:root[data-theme="dark"] .page-item.active .page-link {
  background-color: #0d6efd;
  border-color: #0d6efd;
  color: #ffffff;
}

:root[data-theme="dark"] .page-item.disabled .page-link {
  background-color: #1b1b1b;
  border-color: #2b2f33;
  color: #6c757d;
}

:root[data-theme="dark"] .invoice-tabs.nav-tabs {
  border-bottom-color: #2b2f33;
}

:root[data-theme="dark"] .invoice-tabs.nav-tabs .nav-link {
  color: #adb5bd;
  background-color: transparent;
  border-color: transparent transparent #2b2f33;
}

:root[data-theme="dark"] .invoice-tabs.nav-tabs .nav-link:hover,
:root[data-theme="dark"] .invoice-tabs.nav-tabs .nav-link:focus {
  color: #e9ecef;
  border-color: #2b2f33 #2b2f33 transparent;
  background-color: rgba(255, 255, 255, 0.04);
}

:root[data-theme="dark"] .invoice-tabs.nav-tabs .nav-link.active {
  color: #e9ecef;
  background-color: #1f1f1f;
  border-color: #2b2f33 #2b2f33 #1f1f1f;
}

:root[data-theme="dark"] .btn-light {
  background-color: #1f1f1f;
  border-color: #2b2f33;
  color: #e9ecef;
}

:root[data-theme="dark"] .btn-light:hover {
  background-color: #232323;
  border-color: #3a3f44;
  color: #e9ecef;
}

:root[data-theme="dark"] .btn-outline-light {
  border-color: #adb5bd;
  color: #e9ecef;
}

:root[data-theme="dark"] .btn-outline-light:hover {
  background-color: #e9ecef;
  border-color: #e9ecef;
  color: #121212;
}

:root[data-theme="dark"] .btn-outline-secondary {
  border-color: #adb5bd;
  color: #e9ecef;
}

:root[data-theme="dark"] .btn-outline-secondary:hover {
  background-color: #232323;
  border-color: #e9ecef;
  color: #e9ecef;
}

:root[data-theme="dark"] .border,
:root[data-theme="dark"] .border-top,
:root[data-theme="dark"] .border-right,
:root[data-theme="dark"] .border-bottom,
:root[data-theme="dark"] .border-left,
:root[data-theme="dark"] .border-light,
:root[data-theme="dark"] .border-top.border-light,
:root[data-theme="dark"] .border-right.border-light,
:root[data-theme="dark"] .border-bottom.border-light,
:root[data-theme="dark"] .border-left.border-light {
  border-color: #2b2f33 !important;
}

 .login-floating {
   position: relative;
 }

 .login-floating > input.form-control {
   padding-top: 1.1rem;
   padding-bottom: 0.35rem;
 }

 .login-floating.login-floating--password > input.form-control {
   padding-right: 2.25rem;
 }

 .login-floating > label {
   position: absolute;
   top: 50%;
   left: 0.75rem;
   margin: 0;
   pointer-events: none;
   transform: translateY(-50%);
   transition: all 0.15s ease;
   color: #6c757d;
 }

 .login-floating > input.form-control:focus + label,
 .login-floating > input.form-control:not(:placeholder-shown) + label {
   top: 0.25rem;
   transform: none;
   font-size: 0.75rem;
   opacity: 0.9;
 }

 :root[data-theme="dark"] .login-floating > label {
   color: #adb5bd;
 }

 .login-floating-toggle {
   position: absolute;
   top: 50%;
   right: 0.5rem;
   transform: translateY(-50%);
   border: none;
   background: transparent;
   padding: 0;
   box-shadow: none;
 }

 .login-floating-toggle:focus {
   outline: none;
 }

 :root[data-theme="dark"] .login-floating-toggle .fa {
   color: #e0e5ea;
 }

/* Payment options modal conformant layout */
.payment-total-amount .h3 {
  color: #212529;
}

.payment-options-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

@media (min-width: 576px) {
  .payment-options-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.payment-option-card {
  position: relative;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  min-height: 72px;
}

.payment-option-card.active {
  background-color: #f8f9fa;
}

.payment-option-brand {
  flex-shrink: 0;
}

.payment-option-text {
  min-width: 0;
}

.payment-option-name {
  line-height: 1.3;
}

.payment-option-subtitle {
  line-height: 1.3;
}

.payment-option-radio {
  width: 20px;
  height: 20px;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
}

.payment-option-radio.selected {
  border-color: #007bff;
  background-color: #007bff;
}

.payment-option-radio.selected::after {
  content: '';
  position: absolute;
  top: 4px;
  left: 4px;
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 50%;
}

.payment-redirect-notice {
  line-height: 1.4;
}

/* Payment options modal dark mode */
:root[data-theme="dark"] .payment-total-amount .h3 {
  color: #e9ecef;
}

:root[data-theme="dark"] .payment-option-card {
  background-color: #1f1f1f;
  border-color: #2b2f33;
  color: #e9ecef;
}

:root[data-theme="dark"] .payment-option-card.active {
  background-color: #1a1c1f;
  border-color: #007bff !important;
}

:root[data-theme="dark"] .payment-option-card:hover {
  background-color: #232323;
}

:root[data-theme="dark"] .payment-option-name {
  color: #e9ecef;
}

:root[data-theme="dark"] .payment-option-subtitle {
  color: #adb5bd;
}

:root[data-theme="dark"] .payment-option-radio {
  border-color: #adb5bd;
}

:root[data-theme="dark"] .payment-option-radio.selected {
  border-color: #007bff;
  background-color: #007bff;
}

:root[data-theme="dark"] .payment-redirect-notice {
  color: #adb5bd;
}

:root[data-theme="dark"] .payment-option-brand {
  background-color: #1f1f1f;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,+DAA+D;AAC/D;EACE,sBAAsB;EACtB,sCAAsC;EACtC,sBAAsB;EACtB,yBAAyB;EACzB,wCAAwC;EACxC,wCAAwC;EACxC,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,+DAA+D;EAC/D,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;;EAEE,+DAA+D;EAC/D,oCAAoC;EACpC,wDAAwD;EACxD,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mEAAmE;AACrE;;AAEA;;EAEE,gBAAgB;AAClB;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,8CAA8C;EAC9C,wCAAwC;EACxC,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;;EAEE,sCAAsC;EACtC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;;AAGA;;;EAGE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,yCAAyC;EACzC,uDAAuD;EACvD,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;EACjC,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;EACd,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,gCAAgC;AAClC;;CAEC;GACE,kBAAkB;CACpB;;CAEA;GACE,mBAAmB;GACnB,uBAAuB;CACzB;;CAEA;GACE,sBAAsB;CACxB;;CAEA;GACE,kBAAkB;GAClB,QAAQ;GACR,aAAa;GACb,SAAS;GACT,oBAAoB;GACpB,2BAA2B;GAC3B,0BAA0B;GAC1B,cAAc;CAChB;;CAEA;;GAEE,YAAY;GACZ,eAAe;GACf,kBAAkB;GAClB,YAAY;CACd;;CAEA;GACE,cAAc;CAChB;;CAEA;GACE,kBAAkB;GAClB,QAAQ;GACR,aAAa;GACb,2BAA2B;GAC3B,YAAY;GACZ,uBAAuB;GACvB,UAAU;GACV,gBAAgB;CAClB;;CAEA;GACE,aAAa;CACf;;CAEA;GACE,cAAc;CAChB;;AAED,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["html,\nbody,\n#root {\n  min-height: 100%;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n}\n\n.mboss-app-shell {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.mboss-app-main {\n  flex: 1 0 auto;\n  width: 100%;\n}\n\n.navbar {\n  margin-bottom: 30px;\n  flex-shrink: 0;\n}\n\n.mboss-topbar {\n  min-height: 3.25rem;\n  padding-top: 0.4rem;\n  padding-bottom: 0.4rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  background: #f7f8fa;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  box-shadow: none;\n}\n\n.mboss-topbar .navbar-brand {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.mboss-topbar .navbar-toggler {\n  height: 2rem;\n  width: 2rem;\n  padding: 0;\n  color: #5c6570;\n}\n\n.mboss-footer {\n  flex-shrink: 0;\n  margin-top: 1.5rem;\n  background: #f7f8fa;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n  box-shadow: none;\n}\n\n.mboss-footer__inner {\n  max-width: 1140px;\n  margin: 0 auto;\n  padding: 0.65rem 1rem;\n}\n\n.mboss-footer__meta {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #6c757d;\n  line-height: 1.3;\n}\n\n.mboss-footer__version {\n  font-weight: 400;\n  opacity: 0.9;\n}\n\n/* Quiet hierarchy sidebar rail (aligned with Admin Option B) */\n.nav-section-list {\n  --nav-rail-bg: #f7f8fa;\n  --nav-rail-border: rgba(0, 0, 0, 0.08);\n  --nav-item-fg: #3d4550;\n  --nav-item-muted: #6c757d;\n  --nav-item-hover-bg: rgba(0, 0, 0, 0.04);\n  --nav-active-bg: rgba(0, 123, 255, 0.12);\n  --nav-active-fg: #0056b3;\n  --nav-active-bar: #007bff;\n  --nav-section-fg: #5c6570;\n  --nav-footer-border: rgba(0, 0, 0, 0.08);\n  margin-bottom: 0;\n}\n\n.mboss-side-rail {\n  position: sticky;\n  top: 4.25rem;\n  max-height: calc(100vh - 5rem);\n  display: flex;\n  flex-direction: column;\n  background: #f7f8fa;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 0.25rem;\n  overflow: hidden;\n}\n\n.nav-section-list--rail {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n}\n\n.nav-section-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 0.4rem 0.35rem 0.5rem;\n}\n\n.nav-section-footer {\n  flex-shrink: 0;\n  padding: 0.4rem 0.35rem 0.5rem;\n  border-top: 1px solid var(--nav-footer-border);\n  background: var(--nav-rail-bg, #f7f8fa);\n}\n\n.nav-section-list--mobile .nav-section-body {\n  padding: 0.25rem 0;\n}\n\n.nav-link-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 0.5rem;\n  margin: 0.1rem 0;\n  padding: 0.6rem 0.75rem;\n  border: none;\n  border-radius: 0.3rem;\n  background: transparent;\n  color: var(--nav-item-fg, #3d4550);\n  text-align: left;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 1rem;\n  line-height: 1.3;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n  box-shadow: none;\n}\n\n.nav-link-icon {\n  flex: 0 0 1.25rem;\n  width: 1.25rem;\n  text-align: center;\n  opacity: 0.85;\n}\n\n.nav-link-label {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.nav-link-item:hover {\n  background-color: var(--nav-item-hover-bg, rgba(0, 0, 0, 0.04));\n  color: var(--nav-item-fg, #3d4550);\n  box-shadow: none;\n  text-decoration: none;\n}\n\n.nav-link-item:focus {\n  outline: none;\n}\n\n.nav-link-item:focus-visible {\n  outline: 2px solid var(--nav-active-bar, #007bff);\n  outline-offset: 1px;\n}\n\n.nav-section-list .nav-link-item.active,\n.nav-section-list .nav-link-item.active:hover {\n  background-color: var(--nav-active-bg, rgba(0, 123, 255, 0.12));\n  color: var(--nav-active-fg, #0056b3);\n  box-shadow: inset 3px 0 0 var(--nav-active-bar, #007bff);\n  text-decoration: none;\n}\n\n.nav-section-list .nav-link-item.active .nav-link-icon {\n  opacity: 1;\n}\n\n.nav-section-mobile-logout {\n  margin-top: 0.35rem;\n  padding-top: 0.35rem;\n  border-top: 1px solid var(--nav-footer-border, rgba(0, 0, 0, 0.08));\n}\n\n.nav-section-list .list-group-item,\n.nav-section-list .list-group-item:hover {\n  box-shadow: none;\n}\n\n\n.clickable {\n  cursor: pointer;\n}\n\n.form-signin {\n  width: 100%;\n  max-width: 350px;\n  padding: 40px;\n  /* margin: 50px auto; */\n}\n\n.form-input {\n  width: 100%;\n  max-width: 600px;\n  padding: 15px;\n  margin: 0 auto;\n}\n\n@media (max-width: 575px) {\n  .form-group {\n    margin-bottom: 0px !important;\n  }\n}\n\n.activity-log {\n  width: 100%;\n  max-width: 600px;\n  /* padding: 10px; */\n  margin: 0 auto;\n}\n\n.ticket-comments {\n  width: 100%;\n  max-width: 600px;\n  padding: 10px;\n  margin: 0 auto;\n}\n\n.text-link {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n.card-counter{\n  box-shadow: 4px 4px 10px #DADADA;\n  margin-bottom: 10px;\n  padding: 20px 10px;\n  background-color: #fff;\n  height: 100px;\n  border-radius: 5px;\n  transition: .3s linear all;\n}\n\n.card-counter:hover{\n  box-shadow: 8px 8px 20px #9e9e9e;\n  transition: .3s linear all;\n}\n\n.card-counter:active{\n  box-shadow: 1px 1px 5px #9e9e9e;\n  transition: .3s linear all;\n}\n.card-counter.primary{\n  background-color: #007bff;\n  color: #FFF;\n}\n\n.card-counter.secondary{\n  background-color: #6c757d;\n  color: #FFF;\n}  \n\n.card-counter.danger{\n  background-color: #ef5350;\n  color: #FFF;\n}  \n\n.card-counter.warning{\n  background-color: #ffc107;\n  color: #FFF;\n}  \n\n.card-counter.success{\n  background-color: #66bb6a;\n  color: #FFF;\n}  \n\n.card-counter.info{\n  background-color: #26c6da;\n  color: #FFF;\n}  \n\n.card-counter.dark{\n  background-color: #343a40;\n  color: #FFF;\n}  \n\n.card-counter.light{\n  background-color: #f8f9fa;\n  color: #FFF;\n}  \n\n.card-counter i{\n  font-size: 5em;\n  opacity: 0.2;\n}\n\n.card-counter .count-numbers{\n  position: absolute;\n  right: 28px;\n  top: 20px;\n  font-size: 28px;\n  display: block;\n}\n\n.card-counter .count-name{\n  position: absolute;\n  right: 28px;\n  top: 65px;\n  font-style: italic;\n  text-transform: capitalize;\n  opacity: 0.5;\n  display: block;\n  font-size: 18px;\n}\n\n:root[data-theme=\"dark\"] .card-counter{\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.55);\n}\n\n:root[data-theme=\"dark\"] .card-counter:hover{\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.7);\n}\n\n:root[data-theme=\"dark\"] .card-counter:active{\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);\n}\n\n:root[data-theme=\"dark\"] .table a,\n:root[data-theme=\"dark\"] table a {\n  text-decoration: none !important;\n}\n\n:root[data-theme=\"dark\"] .table a:hover,\n:root[data-theme=\"dark\"] table a:hover,\n:root[data-theme=\"dark\"] .table a:focus,\n:root[data-theme=\"dark\"] table a:focus {\n  text-decoration: none !important;\n}\n\n:root[data-theme=\"dark\"] .table-dark a,\n:root[data-theme=\"dark\"] table.table-dark a,\n:root[data-theme=\"dark\"] .table thead a,\n:root[data-theme=\"dark\"] .table tbody a,\n:root[data-theme=\"dark\"] .table tfoot a {\n  text-decoration: none !important;\n}\n\n.list-group-item:hover {\n  background-color: #f5f5f5;\n  box-shadow: 0px 0px 2px #9e9e9e;\n  transition: .3s linear all;\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.expandable-log .expand-toggle {\n  display: none;\n}\n\n.expandable-log .log-content {\n  max-height: 1.5em;\n  overflow: hidden;\n  transition: max-height 0.3s ease-out;\n}\n\n.expandable-log .expand-toggle:checked ~ label .log-content {\n  max-height: 1000px;\n}\n\n.expand-arrow {\n  display: inline-block;\n  transition: transform 0.2s;\n  color: #6c757d;\n  font-size: 0.875em;\n}\n\n.expandable-log .expand-toggle:checked ~ label .expand-arrow {\n  transform: rotate(180deg);\n}\n\n:root[data-theme=\"dark\"] body {\n  background-color: #121212;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .navbar,\n:root[data-theme=\"dark\"] .mboss-topbar {\n  background-color: #1a1c1f !important;\n  border-bottom-color: #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .mboss-topbar .navbar-toggler {\n  color: #b0b8c1;\n}\n\n:root[data-theme=\"dark\"] .navbar.navbar-light .navbar-brand,\n:root[data-theme=\"dark\"] .navbar.navbar-light .navbar-toggler,\n:root[data-theme=\"dark\"] .navbar.navbar-light .nav-link,\n:root[data-theme=\"dark\"] .mboss-topbar .navbar-brand,\n:root[data-theme=\"dark\"] .mboss-topbar .nav-link {\n  color: #e9ecef !important;\n}\n\n:root[data-theme=\"dark\"] .nav-section-list {\n  --nav-rail-bg: #1a1c1f;\n  --nav-rail-border: #2b2f33;\n  --nav-item-fg: #e0e5ea;\n  --nav-item-muted: #9aa3ad;\n  --nav-item-hover-bg: rgba(255, 255, 255, 0.06);\n  --nav-active-bg: rgba(0, 123, 255, 0.22);\n  --nav-active-fg: #9ec9ff;\n  --nav-active-bar: #4da3ff;\n  --nav-section-fg: #b0b8c1;\n  --nav-footer-border: #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .mboss-side-rail {\n  background: #1a1c1f;\n  border-color: #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .mboss-footer {\n  background: #1a1c1f;\n  border-top-color: #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .mboss-footer__meta {\n  color: #9aa3ad;\n}\n\n:root[data-theme=\"dark\"] .mboss-topbar {\n  background-color: #1a1c1f !important;\n  border-bottom-color: #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .mboss-topbar .navbar-toggler {\n  color: #b0b8c1;\n}\n\n:root[data-theme=\"dark\"] .nav-link-item {\n  color: var(--nav-item-fg);\n}\n\n:root[data-theme=\"dark\"] .nav-link-item:hover {\n  background-color: var(--nav-item-hover-bg);\n  color: var(--nav-item-fg);\n}\n\n:root[data-theme=\"dark\"] .nav-section-list .nav-link-item.active,\n:root[data-theme=\"dark\"] .nav-section-list .nav-link-item.active:hover {\n  background-color: var(--nav-active-bg);\n  color: var(--nav-active-fg);\n  box-shadow: inset 3px 0 0 var(--nav-active-bar);\n}\n\n:root[data-theme=\"dark\"] a:not(.btn):not(.list-group-item):not(.nav-link-item) {\n  color: inherit;\n  text-decoration: none;\n}\n\n\n:root[data-theme=\"dark\"] .card,\n:root[data-theme=\"dark\"] .modal-content,\n:root[data-theme=\"dark\"] .dropdown-menu {\n  background-color: #1f1f1f;\n  color: #e9ecef;\n  border-color: #2b2f33;\n}\n\n/* Card-style table rows */\n.table.table-cards {\n  background: transparent;\n  border-collapse: separate;\n  border-spacing: 0 6px;\n}\n\n.table.table-cards thead th {\n  border: none;\n  padding-bottom: 16px;\n  font-weight: 600;\n  color: #495057;\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n}\n\n.table.table-cards tbody tr {\n  background: #f8f9fa;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.15s ease, transform 0.15s ease;\n  margin-bottom: 12px;\n}\n\n.table.table-cards tbody tr:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n.table.table-cards tbody tr td {\n  border: none;\n  padding: 12px 10px;\n  vertical-align: middle;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  white-space: normal;\n  word-wrap: break-word;\n  max-width: 200px;\n}\n\n.table.table-cards tbody tr td:first-child {\n  border-left: 1px solid transparent;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.table.table-cards tbody tr td:last-child {\n  border-right: 1px solid transparent;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n/* Optional subtle cell borders for readability */\n.table.table-cards tbody tr td:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 20%;\n  bottom: 20%;\n  width: 1px;\n  background: rgba(0, 0, 0, 0.06);\n}\n\n.table.table-cards tbody tr td {\n  position: relative;\n}\n\n/* Dark mode */\n:root[data-theme=\"dark\"] .table.table-cards thead th {\n  color: #adb5bd;\n}\n\n:root[data-theme=\"dark\"] .table.table-cards tbody tr {\n  background: #1e1f22;\n  border-color: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n:root[data-theme=\"dark\"] .table.table-cards tbody tr:hover {\n  background: #2a2d31;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n}\n\n:root[data-theme=\"dark\"] .table.table-cards tbody tr:hover td {\n  color: #f3f4f6;\n}\n\n:root[data-theme=\"dark\"] .table.table-cards tbody tr:hover td a {\n  color: #60a5fa;\n}\n\n:root[data-theme=\"dark\"] .table.table-cards tbody tr:hover td a:hover {\n  color: #93c5fd;\n}\n\n:root[data-theme=\"dark\"] .table.table-cards tbody tr td:not(:last-child)::after {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n:root[data-theme=\"dark\"] .table {\n  color: #d1d5db;\n}\n\n:root[data-theme=\"dark\"] .table thead th {\n  color: #e0e5ea;\n}\n\n:root[data-theme=\"dark\"] .table td,\n:root[data-theme=\"dark\"] .table th {\n  border-color: #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .list-group-item {\n  background-color: #1f1f1f;\n  color: #e9ecef;\n  border-color: #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .list-group-item.active {\n  background-color: #007bff;\n  border-color: #007bff;\n  color: #ffffff;\n}\n\n:root[data-theme=\"dark\"] .list-group-item.active:hover {\n  background-color: #0069d9;\n  border-color: #0062cc;\n  color: #ffffff;\n}\n\n:root[data-theme=\"dark\"] .form-control,\n:root[data-theme=\"dark\"] .custom-select {\n  background-color: #1b1b1b;\n  color: #e9ecef;\n  border-color: #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .form-control::placeholder {\n  color: #adb5bd;\n}\n\n:root[data-theme=\"dark\"] input[type=\"number\"],\n:root[data-theme=\"dark\"] input[type=\"number\"]::-webkit-inner-spin-button,\n:root[data-theme=\"dark\"] input[type=\"number\"]::-webkit-outer-spin-button {\n  color-scheme: dark;\n}\n\n:root[data-theme=\"dark\"] input[type=\"number\"]::-webkit-inner-spin-button,\n:root[data-theme=\"dark\"] input[type=\"number\"]::-webkit-outer-spin-button {\n  filter: invert(1) opacity(0.85);\n}\n\n:root[data-theme=\"dark\"] .form-group .fa,\n:root[data-theme=\"dark\"] .input-group .fa {\n  color: #e0e5ea;\n}\n\n:root[data-theme=\"dark\"] .form-control + .btn .fa,\n:root[data-theme=\"dark\"] .form-control + button .fa {\n  color: #e0e5ea;\n}\n\n:root[data-theme=\"dark\"] .bg-light {\n  background-color: #1f1f1f !important;\n}\n\n:root[data-theme=\"dark\"] .text-dark {\n  color: #e9ecef !important;\n}\n\n:root[data-theme=\"dark\"] .text-secondary {\n  color: #adb5bd !important;\n}\n\n:root[data-theme=\"dark\"] a:not(.btn):not(.list-group-item):not(.nav-link-item) {\n  color: inherit;\n  text-decoration: underline;\n}\n\n:root[data-theme=\"dark\"] a:not(.btn):not(.list-group-item):not(.nav-link-item):hover {\n  color: inherit;\n  opacity: 0.9;\n}\n\n:root[data-theme=\"dark\"] .list-group-item:hover {\n  background-color: #232323;\n  box-shadow: 0px 0px 2px #343a40;\n}\n\n:root[data-theme=\"dark\"] .page-link {\n  background-color: #1f1f1f;\n  border-color: #2b2f33;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .page-link:hover {\n  background-color: #232323;\n  border-color: #3a3f44;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .page-item.active .page-link {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  color: #ffffff;\n}\n\n:root[data-theme=\"dark\"] .page-item.disabled .page-link {\n  background-color: #1b1b1b;\n  border-color: #2b2f33;\n  color: #6c757d;\n}\n\n:root[data-theme=\"dark\"] .invoice-tabs.nav-tabs {\n  border-bottom-color: #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .invoice-tabs.nav-tabs .nav-link {\n  color: #adb5bd;\n  background-color: transparent;\n  border-color: transparent transparent #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .invoice-tabs.nav-tabs .nav-link:hover,\n:root[data-theme=\"dark\"] .invoice-tabs.nav-tabs .nav-link:focus {\n  color: #e9ecef;\n  border-color: #2b2f33 #2b2f33 transparent;\n  background-color: rgba(255, 255, 255, 0.04);\n}\n\n:root[data-theme=\"dark\"] .invoice-tabs.nav-tabs .nav-link.active {\n  color: #e9ecef;\n  background-color: #1f1f1f;\n  border-color: #2b2f33 #2b2f33 #1f1f1f;\n}\n\n:root[data-theme=\"dark\"] .btn-light {\n  background-color: #1f1f1f;\n  border-color: #2b2f33;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .btn-light:hover {\n  background-color: #232323;\n  border-color: #3a3f44;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .btn-outline-light {\n  border-color: #adb5bd;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .btn-outline-light:hover {\n  background-color: #e9ecef;\n  border-color: #e9ecef;\n  color: #121212;\n}\n\n:root[data-theme=\"dark\"] .btn-outline-secondary {\n  border-color: #adb5bd;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .btn-outline-secondary:hover {\n  background-color: #232323;\n  border-color: #e9ecef;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .border,\n:root[data-theme=\"dark\"] .border-top,\n:root[data-theme=\"dark\"] .border-right,\n:root[data-theme=\"dark\"] .border-bottom,\n:root[data-theme=\"dark\"] .border-left,\n:root[data-theme=\"dark\"] .border-light,\n:root[data-theme=\"dark\"] .border-top.border-light,\n:root[data-theme=\"dark\"] .border-right.border-light,\n:root[data-theme=\"dark\"] .border-bottom.border-light,\n:root[data-theme=\"dark\"] .border-left.border-light {\n  border-color: #2b2f33 !important;\n}\n\n .login-floating {\n   position: relative;\n }\n\n .login-floating > input.form-control {\n   padding-top: 1.1rem;\n   padding-bottom: 0.35rem;\n }\n\n .login-floating.login-floating--password > input.form-control {\n   padding-right: 2.25rem;\n }\n\n .login-floating > label {\n   position: absolute;\n   top: 50%;\n   left: 0.75rem;\n   margin: 0;\n   pointer-events: none;\n   transform: translateY(-50%);\n   transition: all 0.15s ease;\n   color: #6c757d;\n }\n\n .login-floating > input.form-control:focus + label,\n .login-floating > input.form-control:not(:placeholder-shown) + label {\n   top: 0.25rem;\n   transform: none;\n   font-size: 0.75rem;\n   opacity: 0.9;\n }\n\n :root[data-theme=\"dark\"] .login-floating > label {\n   color: #adb5bd;\n }\n\n .login-floating-toggle {\n   position: absolute;\n   top: 50%;\n   right: 0.5rem;\n   transform: translateY(-50%);\n   border: none;\n   background: transparent;\n   padding: 0;\n   box-shadow: none;\n }\n\n .login-floating-toggle:focus {\n   outline: none;\n }\n\n :root[data-theme=\"dark\"] .login-floating-toggle .fa {\n   color: #e0e5ea;\n }\n\n/* Payment options modal conformant layout */\n.payment-total-amount .h3 {\n  color: #212529;\n}\n\n.payment-options-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n@media (min-width: 576px) {\n  .payment-options-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.payment-option-card {\n  position: relative;\n  padding: 0.75rem 1rem;\n  border-radius: 0.5rem;\n  min-height: 72px;\n}\n\n.payment-option-card.active {\n  background-color: #f8f9fa;\n}\n\n.payment-option-brand {\n  flex-shrink: 0;\n}\n\n.payment-option-text {\n  min-width: 0;\n}\n\n.payment-option-name {\n  line-height: 1.3;\n}\n\n.payment-option-subtitle {\n  line-height: 1.3;\n}\n\n.payment-option-radio {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #adb5bd;\n  border-radius: 50%;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.payment-option-radio.selected {\n  border-color: #007bff;\n  background-color: #007bff;\n}\n\n.payment-option-radio.selected::after {\n  content: '';\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 8px;\n  height: 8px;\n  background-color: #fff;\n  border-radius: 50%;\n}\n\n.payment-redirect-notice {\n  line-height: 1.4;\n}\n\n/* Payment options modal dark mode */\n:root[data-theme=\"dark\"] .payment-total-amount .h3 {\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .payment-option-card {\n  background-color: #1f1f1f;\n  border-color: #2b2f33;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .payment-option-card.active {\n  background-color: #1a1c1f;\n  border-color: #007bff !important;\n}\n\n:root[data-theme=\"dark\"] .payment-option-card:hover {\n  background-color: #232323;\n}\n\n:root[data-theme=\"dark\"] .payment-option-name {\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .payment-option-subtitle {\n  color: #adb5bd;\n}\n\n:root[data-theme=\"dark\"] .payment-option-radio {\n  border-color: #adb5bd;\n}\n\n:root[data-theme=\"dark\"] .payment-option-radio.selected {\n  border-color: #007bff;\n  background-color: #007bff;\n}\n\n:root[data-theme=\"dark\"] .payment-redirect-notice {\n  color: #adb5bd;\n}\n\n:root[data-theme=\"dark\"] .payment-option-brand {\n  background-color: #1f1f1f;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
